import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import CreateAssetComponent from '../../../Components/AssetComponent/CreateAssetComponent';

const CreateAsset = (props) => {
    let navigate = useNavigate();
    const params = useParams();

    return (
        <div>
            <CreateAssetComponent {...props} navigate={navigate} id={params.id} />
        </div>
    );
}

export default CreateAsset